<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getAiproxyBatchEnabledActions } from '@Ai/utils/aiproxyEnabledActions'
import SingleActionsMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'AiProxyNodeList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'ai_proxy_nodes',
        getParams: this.getParam,
        filterOptions: {
          name: {
            label: this.$t('common.name'),
            filter: true,
            formatter: val => `name.contains(${val})`,
          },
          address: {
            label: this.$t('aice.aiproxy.address'),
            filter: true,
            formatter: val => `address.contains(${val})`,
          },
        },
      }),
      exportDataOptions: {
        items: [
          { label: 'ID', key: 'id' },
          { label: this.$t('common.name'), key: 'name' },
          { label: this.$t('aice.aiproxy.address'), key: 'address' },
          { label: this.$t('aice.aiproxy.access_address'), key: 'access_address' },
        ],
      },
      groupActions: [
        {
          label: this.$t('common.create'),
          permission: 'ai_proxy_nodes_create',
          action: () => {
            this.$router.push({ name: 'AiProxyNodeCreate' })
          },
          meta: () => ({ buttonType: 'primary', validate: true }),
          hidden: () => this.$store.getters.isProjectMode,
        },
        {
          label: this.$t('common.batchAction'),
          actions: () => [
            ...getAiproxyBatchEnabledActions(this, 'ai_proxy_nodes', this.$t('aice.aiproxy.proxy_node')),
            {
              label: this.$t('table.action.delete'),
              permission: 'ai_proxy_nodes_delete',
              action: () => {
                this.createDialog('DeleteResDialog', {
                  vm: this,
                  data: this.list.selectedItems,
                  columns: this.columns,
                  title: this.$t('table.action.delete'),
                  name: this.$t('aice.aiproxy.proxy_node'),
                  onManager: this.onManager,
                })
              },
              meta: () => {
                const items = this.list.selectedItems || []
                if (items.some(item => item.id === 'primary')) {
                  return { validate: false, tooltip: this.$t('aice.aiproxy.primary_node_undeletable') }
                }
                return { validate: this.list.allowDelete() }
              },
            },
          ],
        },
      ],
    }
  },
  created () {
    this.initSidePageTab('detail')
    this.list.fetchData()
  },
  methods: {
    getParam () {
      return {
        ...this.getParams,
        details: true,
        scope: this.$store.getters.scope,
      }
    },
  },
}
</script>
